import "@fontsource/young-serif/index.css";
import "@fontsource/nunito-sans/400.css";
import "@fontsource/nunito-sans/700.css";
import "./styles/tokens.css";

await import("./pt-app.js");
